module.exports = __webpack_public_path__ + "media/theme/ico-plus-1-30bc0620.png";